import { DEFAULT_ICONS } from "PFComponents/icon_grid_select/utils";
import { IconName } from "PFTheme/graphics/icons";

export const DEFAULT_CATEGORY_ICON: IconName = "non-demand";

export const validateCategoryIcon = (iconNameToCheck?: string | null): IconName | null =>
  iconNameToCheck && DEFAULT_ICONS.includes(iconNameToCheck as IconName)
    ? (iconNameToCheck as IconName)
    : null;
